import React, {useEffect, useRef, useState} from "react";
import mapboxgl from 'mapbox-gl';
import { makeStyles } from '@material-ui/core/styles';
import { createPortal } from "react-dom";
import MarcadorGoT from "./Marcador2";
import 'mapbox-gl/dist/mapbox-gl.css';
import Popup from "./popup";
import PopupOtb from "./popupOTB";
import MarcadorEncuesta from "./MarcadorEncuesta";
import PopupEncuesta from "./popupEncuesta";
const useStyles = makeStyles({
    miclase:{".map-container":{
        height: "400px",
      }},
  });

const listPreg1=[
    {Id:1,cadena:"Si"},
    {Id:2,cadena:"No"},    
]

const listPercep=[
    {Id:1,cadena:"Buena"},
    {Id:2,cadena:"Indecisa"},    
    {Id:3,cadena:"Mala"},    
]

const listEdad=[
    {Id:1,cadena:"18/25"},
    {Id:2,cadena:"26/35"},    
    {Id:3,cadena:"36/45"},    
    {Id:3,cadena:"46/100"},    
]

const listPreg2=[
    {Id:1,cadena:"Si Votaría"},
    {Id:2,cadena:"Indecisa"},
    {Id:3,cadena:"No Votaría"},    
]

const listPreg3=[
    {Id:1,cadena:"Si"},
    {Id:2,cadena:"No"},
]

 

function Mapa({lista, listMarcador, listEleccion, listMarcaEncuesta, listPoliOtb,listColOtb, listNumOtb,listColPolig  }) {

    
    const classes = useStyles();
    const mapContainer = useRef(null);
    const mapRef = useRef(null);
    const markerRef = useRef()
    const [long] = useState(-66.15492523373541); 
    const [lat] = useState(-17.41283598717285 );
    const [zoom] = useState(13);       
    const iconpendiente = '/marcador-pendiente.svg' 
    const iconRechazo = '/marcador-rechazado.svg'
    const iconValido = '/marcador-valido.svg' 
    const [regisSelect, setRegisSelect] = useState([]);
    const [marcadores, setMarcadores] = useState([]);
    const [marcaEncuesta, setMarcaEncuesta] = useState([]);
    const [regisPopUp, setRegisPopUp] = useState([]);
    const [regisPopUpOtb, setRegisPopUpOtb] = useState([]);
    const [regisPopUpEncuesta, setRegisPopUpEncuesta] = useState([]);
    const [listaNum, setListaNum] = useState([]);
    const [hoveredDistrict, _setHoveredDistrict] = useState(null);
     
    let hoveredStateId = null;
    let stateName = null;

 
    useEffect(() => {       
        //console.log(typeof lista, lista);
        //console.log("llegando al mapa");
        
        mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_KEY;
        mapRef.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: "mapbox://styles/mapbox/light-v10",
            center: [lista[0][0], lista[0][1]],
            zoom: zoom            
        });

         
        //mapRef.addControl(new mapboxgl.NavigationControl());
       /*  mapRef.current.on('click', (e) => {                
            e.preventDefault()
            let nvoMarcador=[]
            //nvoMarcador=regisSelect           
            const geometry = { coordinates:[e.lngLat.lng.toFixed(5), e.lngLat.lat.toFixed(5)] } 
            const properties = {texto:"prueba"}    
            nvoMarcador= {geometry,properties,original:{Id:contador}}
           // console.log( contador, nvoMarcador);
            let auxLocalStg =  localStorage.getItem('auxPol') ?  JSON.parse(localStorage.getItem('auxPol')):[]
            if (auxLocalStg.length!==0) {
                //console.log(auxLocalStg);
                
                auxLocalStg.push(nvoMarcador)
                localStorage.setItem('auxPol',JSON.stringify(auxLocalStg))
            }
            else{
                localStorage.setItem('auxPol',JSON.stringify([nvoMarcador]))
            }
            
            setActualiza()
            setContador(contador+1)               
        }); */
        setRegisSelect(lista)
        return () => {
            mapRef.current.remove()
        }
    }, [    ]);

    useEffect(()=>{
       if (lista.length!==0) {
        //console.log(listMarcador);
        
        const auxCoordenadas=lista
        /*  lista.forEach((registro)=>{
            auxCoordenadas.push({... registro.coordinates})
        })  */
        mapRef.current.on('load', () => {
            // Add a data source containing GeoJSON data.
            mapRef.current.addSource('maine', {
                'type': 'geojson',
                'data': {
                    'type': 'Feature',
                    'geometry': {
                        'type': 'Polygon',
                        // These coordinates outline Maine.
                        'coordinates': [
                            auxCoordenadas
                        ]
                    }
                }
            });

            // Add a new layer to visualize the polygon.
          /*   mapRef.current.addLayer({
                'id': 'maine',
                'type': 'fill',
                'source': 'maine', // reference the data source
                'layout': {},
                'paint': {
                    'fill-color': '#0080ff', // blue color fill
                    'fill-opacity': 0.5
                }
            }); */
            // Add a black outline around the polygon.
            mapRef.current.addLayer({
                'id': 'outline',
                'type': 'line',
                'source': 'maine',
                'layout': {},
                'paint': {
                    'line-color': '#24AF88',
                    'line-width': 3
                }
            });
            });
            setMarcadores(listMarcador)
            setMarcaEncuesta(listMarcaEncuesta)
        }
 
    },[lista ])

     useEffect(()=>{
      
                
       if (listPoliOtb.length!==0) {
       //console.log(listColOtb);
        
        const auxCoordenadas=listPoliOtb
        /*  lista.forEach((registro)=>{
            auxCoordenadas.push({... registro.coordinates})
        })  */
        mapRef.current.on('load', () => {
            // Add a data source containing GeoJSON data.
            mapRef.current.addSource('otbs', {
                'type': 'geojson',
                'data':auxCoordenadas/* {  
                    'type': 'Feature',
                    'geometry': {
                        'type': 'MultiPolygon',                        
                        'coordinates': auxCoordenadas                        
                    }
                }  */
            });

            // Add a new layer to visualize the polygon.
            mapRef.current.addLayer({
                'id': 'fill-otbs',
                'type': 'fill',
                'source': 'otbs', // reference the data source
                'layout': {},
                'paint': {
                    'fill-color':  listColOtb,//'#caebe1', // blue color fill
                    'fill-opacity': 0.5
                }
            });
            // Add a black outline around the polygon.
            mapRef.current.addLayer({
                'id': 'outline-otbs',
                'type': 'line',
                'source': 'otbs',
                'layout': {},
                'paint': {
                    'line-color':listColPolig,////["match",["get", "IdOTB"],[81],'#eb4034',[82],"#97ca7f",'#cedded'],
                    'line-width': 3
                }
            });
            });
             
            setListaNum(listNumOtb)
        }
 
    },[listPoliOtb ])

    const obtnLeyenda=(lista, valor)=>{
        let leyenda=""
        if (valor!=="0" && valor!==0 ) 
        {
            const filtro = lista.filter((objeto)=> objeto.Id === valor)            
            if (filtro.length !==0) {
                leyenda= !filtro[0].cadena ?"": filtro[0].cadena  
            }      
        }      
        return leyenda
    }

    const onClickUnidad=(aux)=>{
        
        //console.log(aux);
        const nvo={...aux,
            properties:{texto: aux.original.nom, dir: aux.original.dir, 
                otb:aux.original.otbNom},
            geometry:{coordinates:aux.coordinates}}
        //console.log(nvo);
        setRegisPopUpOtb([])
        setRegisPopUp(nvo)
    }

    const onClickEncuesta=(aux)=>{
        
        //console.log(aux);
        const nvo={...aux,
            properties:{texto: aux.original.Nom, Edad: obtnLeyenda(listEdad, aux.original.Edad), 
                P1: obtnLeyenda(listPreg1, aux.original.P1), P2: obtnLeyenda(listPreg2, aux.original.P2),
                P3: obtnLeyenda(listPreg3, aux.original.P3), Percep: obtnLeyenda(listPercep, aux.original.Perp) },
            geometry:{coordinates:aux.coordinates}}
        //console.log(nvo);
        setRegisPopUpOtb([])
        setRegisPopUpEncuesta(nvo)
    }

    const onClickOtb=(aux)=>{
        //console.log(aux);
        setRegisPopUp([])
        let textoEleccionArr=[]
        if (listEleccion.length!==0) {
            const filtro = listEleccion.filter((eleccion)=> eleccion.Otb===aux.Ord)
            if (filtro.length!==0) {
                textoEleccionArr={...filtro[0] }    
            }
            /* else{
                textoEleccionArr={Registro: "Sin Registro de votación"}
            } */
            //console.log(filtro);            
            
        }
        setRegisPopUpOtb({...aux,
            properties:{texto: aux.Nom, ...textoEleccionArr},
            geometry:{coordinates:aux.coordinates}})
    }

    return (
    <div className={classes.miclase} style={{width:window.innerWidth - 290,height: window.innerHeight - 140}} >
       
        {<div id="districtDetailMap" className={"map"} >
            <div style={{width:window.innerWidth - 290,height: window.innerHeight - 140}} ref={mapContainer}>
            </div>
   
            {marcadores.length !== 0 ?
                marcadores.map((elemento,index)=>
                    <MarcadorGoT
                    key={elemento.original.id}
                    map={mapRef.current}
                    feature={elemento}
                    onClick={onClickUnidad}
                /> 
                )
               
            :null }
           
            {marcaEncuesta.length !== 0 ?
                marcaEncuesta.map((elemento,index)=>{

                    const icon = elemento.original.Perp === 2 ? iconpendiente:(elemento.original.Perp === 1 ?  iconValido : iconRechazo)
                    return<MarcadorEncuesta
                        key={elemento.original.Id}
                        map={mapRef.current}
                        feature={elemento}
                        url={icon}
                        onClick={onClickEncuesta}
                    /> 
                }
                )
               
            :null }

            {listaNum.length !== 0 ?
                listaNum.map((elemento,index)=>{
                    const estilo = elemento.Ord < 10 ?{width:"20px", height:"35px"}:{width:"30px", height:"38px"}
                    return<MarcadorGoT
                    key={elemento.id}
                    map={mapRef.current}
                    feature={elemento}
                    onClick={onClickOtb}
                    estilo={estilo}
                    url={`https://daduva-cartografia.sfo3.cdn.digitaloceanspaces.com/Sec/Secc${elemento.Ord}.svg`}
                /> 
               } )
               
            :null  }

            {mapRef.current && regisPopUp.length!==0 ? (
                <Popup
                    map={mapRef.current}
                    activeFeature={regisPopUp}
                />
            )
            :null}

             {mapRef.current && regisPopUpOtb.length!==0 ? (
                <PopupOtb
                    map={mapRef.current}
                    activeFeature={regisPopUpOtb}
                />
            )
            :null}

            {mapRef.current && regisPopUpEncuesta.length!==0 ? (
                <PopupEncuesta
                    map={mapRef.current}
                    activeFeature={regisPopUpEncuesta}
                />
            )
            :null}
        </div>}
    </div>
    );
}

export default Mapa;